import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66978cc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-toggler" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "ui-toggler_input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpdateText()))
    }, null, 544), [
      [_vModelCheckbox, _ctx.innerValue]
    ])
  ]))
}